import { render } from "./AnimatedText.vue?vue&type=template&id=7999a060&scoped=true"
import script from "./AnimatedText.vue?vue&type=script&lang=js"
export * from "./AnimatedText.vue?vue&type=script&lang=js"

import "./AnimatedText.vue?vue&type=style&index=0&id=7999a060&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7999a060"],['__file',"src/scripts/view/portfolio/sections/AnimatedText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7999a060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7999a060', __exports__)) {
    api.reload('7999a060', __exports__)
  }
  
  module.hot.accept("./AnimatedText.vue?vue&type=template&id=7999a060&scoped=true", () => {
    api.rerender('7999a060', render)
  })

}


export default __exports__